<template>
  <div class='notifications-list'>
    <div class='notification-row' v-for='(notification, index) in notifications' :key='index'>
      <notification-row :notification='notification'/>
      <v-divider class='rows-divider'/>
    </div>
  </div>
</template>

<script>
import NotificationRow from '@/components/notifications/NotificationRow.vue';

export default {
  name: 'NotificationsList',
  props: {
    notifications: {
      required: true,
      type: Array,
    },
  },
  components: {
    NotificationRow,
  },
};
</script>

<style lang='scss' scoped>

.notifications-list {
  padding-left: 20px;
  padding-top: 16px;
  .rows-divider {
    margin-top: 8px;
    margin-bottom: 8px;
    height: 1px;
    width: 342px;
    opacity: 0.5;
    background-color: var(--border-primary);
  }
}
</style>
